import { forwardRef, useId, type InputHTMLAttributes } from 'react'
import { cn } from '../utils/cn'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string
  error?: string
}

const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { label, error, className, disabled, id: idProp, ...rest },
  ref,
) {
  const generatedId = useId()
  const id = idProp ?? generatedId
  const messageId = `${id}-message`

  return (
    <div
      className={cn(
        'input-wrapper',
        error && 'input-error',
        disabled && 'input-disabled',
        className,
      )}
    >
      <label className="input-label" htmlFor={id}>
        {label}
      </label>
      <input
        ref={ref}
        id={id}
        className="input-field"
        disabled={disabled}
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? messageId : undefined}
        {...rest}
      />
      <div className="input-message">
        {error && (
          <p className="input-message-text" id={messageId}>
            {error}
          </p>
        )}
      </div>
    </div>
  )
})

export { Input }
export type { InputProps }
